import styled from "styled-components";

import { Text } from "@ui/Atoms";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_24};
  height: 100%;
  width: 100%;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    justify-content: center;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_16};
`;

export const Title = styled(Text).attrs({
  $style: {
    default: "bold_40",
    smallTablet: "bold_56",
    smallDesktop: "bold_72",
  },
  $color: "grey900",
  $breakWord: true,
})``;

export const Subtitle = styled(Text).attrs({
  $style: {
    default: "regular_16",
    smallDesktop: "regular_18",
  },
  $color: "grey900",
})``;

export const CallToActionWrapper = styled.div`
  width: fit-content;
`;
